import React from "react"
import Card from "../../../../containers/Card/Card"
import AcceptableTypesOfIdentificationSubtitle from "../AcceptableTypesOfIdentificationSubtitle"
import {
	AcceptableTypesOfIdentificationType,
	CheckboxStructure,
	hasExceptionsOnAcceptableTypesOfIdentification,
} from "../../RiskSettingsUtils"
import TitleWithBadge from "../../../TitleWithBadge/TitleWithBadge"

interface AcceptableTypesOfIdentificationProps {
	value: AcceptableTypesOfIdentificationType
	defaultValue?: AcceptableTypesOfIdentificationType
	checkboxStructure: CheckboxStructure
}

function IdentificationCheckedIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" className="is-flex-shrink-0">
			<circle cx={10} cy={10} r={10} fill="#7CE1A5" />
			<path
				fill="#fff"
				fillRule="evenodd"
				d="m15.53 7.53-6.364 6.363a.75.75 0 0 1-1.06 0l-3.637-3.636 1.06-1.061 3.106 3.106L14.47 6.47l1.06 1.06Z"
				clipRule="evenodd"
			/>
		</svg>
	)
}

function IdentificationUncheckedIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" className="is-flex-shrink-0">
			<circle cx={10} cy={10} r={10} fill="#B0B2B5" />
			<path fill="#fff" d="M4 9h12v2H4z" />
		</svg>
	)
}

interface IdentificationTypeWithIconProps {
	label: string
	checked: boolean
}

function IdentificationTypeWithIcon({label, checked}: IdentificationTypeWithIconProps) {
	return (
		<div className="label-and-icon-container">
			<span>{label}</span>
			{checked ? <IdentificationCheckedIcon /> : <IdentificationUncheckedIcon />}
		</div>
	)
}

export default function AcceptableTypesOfIdentificationViewMode({
	value,
	defaultValue,
	checkboxStructure,
}: AcceptableTypesOfIdentificationProps) {
	return (
		<div className="risk-settings-card">
			<Card
				title="Acceptable Types of Identification"
				subtitle={<AcceptableTypesOfIdentificationSubtitle />}
				className="header-with-large-gap"
				icon="user-id-cards---users"
			>
				<div className="acceptable-types-of-identification">
					{checkboxStructure.map(({group, title, items}) => (
						<div className="values-section" key={group}>
							<TitleWithBadge
								title={title}
								showBadge={
									defaultValue && hasExceptionsOnAcceptableTypesOfIdentification(value[group], defaultValue[group])
								}
								badgeText="Exceptions"
								badgeTooltip={`This onboarding rules for this Org<br>
									include exceptions to the bank's<br>
									default onboarding rules.`}
								badgeTooltipClassname="risk-settings-badge-tooltip"
								badgeTooltipKey={`${group}-badge-tooltip`}
								heading="h3"
							/>
							{items.map(({name, label}) => {
								return <IdentificationTypeWithIcon key={name} label={label} checked={value[group][name]} />
							})}
						</div>
					))}
				</div>
			</Card>
		</div>
	)
}
